import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@env/environment';

export const apiPrefixInterceptor: HttpInterceptorFn = (req, next) => {
    if (!/^(http|https):/i.test(req.url)) {
        req = req.clone({
            url: environment.apiUrl + (req.url.startsWith('/') ? '' : '/') + req.url
        });
    }
    return next(req);
};
